import { AXNUIRetryMessageContainer } from "@iddataweb/idw-common-ui/containers";
import { AXNUIContent, AXNUITheme } from "@iddataweb/idw-common-ui/types";
import { AssertionErrorMessages } from "../assertion-error-messages/assertion-error-messages";
import { RetryErrorMessage } from "../retry-error-message/retry-error-message";
import styles from "./error-messages-container.less";

type ErrorMessagesContainerProps = {
    showPolicyDecisionRetryError: boolean;
    showInlineRetryError: boolean;
    content: AXNUIContent;
    theme: AXNUITheme;
    useThemedUI: boolean;
    inlineErrorMessage: string;
    showAssertionErrors: boolean;
    assertionErrorMessages: Array<string>;
}

export const ErrorMessagesContainer = (props: ErrorMessagesContainerProps) => {
    const {
        showPolicyDecisionRetryError,
        showInlineRetryError,
        content,
        theme,
        useThemedUI,
        inlineErrorMessage,
        showAssertionErrors,
        assertionErrorMessages
    } = props;

    return (
        <div className={styles.errorMessagesContainer}>
            {showPolicyDecisionRetryError && (
                <AXNUIRetryMessageContainer
                    axnuiContent={content}
                    useThemedUI={useThemedUI}
                    font={theme.policyRetryMessage.font}
                    fontColor={theme.policyRetryMessage.fontColor}
                    borderColor={theme.policyRetryMessage.borderColor}
                    backgroundColor={theme.policyRetryMessage.backgroundColor}
                    borderWidth={theme.policyRetryMessage.borderWidth}
                    cornerRadius={theme.policyRetryMessage.cornerRadius} />
            )}
            {showInlineRetryError && (
                <RetryErrorMessage message={inlineErrorMessage} />
            )}
            {showAssertionErrors && (
                <AssertionErrorMessages messages={assertionErrorMessages} />
            )}
        </div>
    );
};